export const TOOLTIP_CONTAINER_ID = 'tooltipContainer';
